import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowDown14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.74999 10.1893L10.9696 6.96967L12.0303 8.03033L6.99993 13.0607L1.9696 8.03033L3.03026 6.96967L6.24999 10.1894L6.24999 1H7.74999L7.74999 10.1893Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowDown14.displayName = 'ArrowDown14';
export default ArrowDown14;
